// Kuviteltu tulevaisuus (#1062): the outcome tabs, the world, the actor filter, the scrolling line and the
// effect verdict. Merged into the `futureReimagined` namespace by futureReimaginedStrings.js.

export const futureOutcomeFi = {
  scenario: {
    label: "Skenaario",
    sources: { expert: "Asiantuntijaskenaariot", workshop: "Työpajan skenaariot", own: "Omat skenaariot" },
    placeholder: "Paikkamerkki: asiantuntijoiden skenaariot korvaavat nämä tekstit.",
    stale: "Skenaario on muuttunut tämän kulun jälkeen: kulku pitää kuvitella uudelleen.",
    read: "Lue skenaario",
    close: "Sulje",
    level: "Optimismin taso {{level}}",
    judged: "Ratkaisut arvioidaan realistisesti tässä maailmassa: ei armollisesti eikä ankarasti.",
  },
  reading: {
    title: "Mitä skenaario tekee ratkaisujen uhille",
    pressure: { stronger: "vahvistaa", as_is: "ennallaan", weaker: "heikentää", removed: "poistaa" },
    timing: { earlier: "aiemmin", same: "", later: "myöhemmin" },
    kind: { trigger: "aiheutti kohtalon", setAside: "sivuutettu uhka" },
    behind: "Skenaariossa: {{text}}",
    none: "Skenaario ei muuta tämän kulun kohtaloiden uhkia.",
    differs: "Mikä skenaarioissa eroaa",
    differsIntro: "Uhat ja suhteet, joihin skenaariot vaikuttavat eri tavoin, ja skenaarion kohta, johon arvio perustuu. Kaikki skenaariot luettiin kerralla rinnakkain.",
    noDiffer: "Skenaariot eivät eroa lukittujen ratkaisujen uhkien osalta.",
    notRead: "Skenaarioita ei ole vielä luettu.",
    failed: "Skenaarioiden luenta epäonnistui: {{message}}",
  },
  impact: {
    title: "Skenaario ja sen vaikutus",
    show: "Näytä skenaarion teksti",
    hide: "Piilota teksti",
  },
  worldAdmin: {
    title: "Skenaariot",
    source: "Lähde: {{source}}, {{count}} skenaariota. Lähteen voi vaihtaa Sisällöstä (Ennusteen skenaariot).",
    none: "Valitussa lähteessä on {{count}} skenaariota; tarvitaan vähintään {{min}}. Vaihda lähde tai lisää skenaariot Sisällössä.",
    simulate: "Kuvittele kaikki skenaariot",
    simulating: "Kuvitellaan…",
    rerun: "Kuvittele uudelleen",
    analyse: "Arvioi vaikuttavuus uudelleen",
    analysing: "Arvioidaan…",
    readingStatus: { running: "luetaan", done: "luettu", failed: "luenta epäonnistui" },
    status: { running: "kuvitellaan", done: "valmis", failed: "epäonnistui" },
  },
  stageBar: {
    label: "Vaiheet",
    interplay: "Ristivaikutukset",
    voting: "Äänestys",
    locked: "Lukitus",
    simulated: "Tulevaisuustestaus",
  },
  howWeGotHere: "Miten tähän päädyttiin: ristivaikutukset",
  lockedStrip: {
    label: "Lukittu",
    override: "Valinta poikkeaa äänestyksestä",
    stale: "muuttunut lukituksen jälkeen",
  },
  views: {
    label: "Näkymä",
    timeline: "Aikajana",
    compare: "Vertailu",
    fates: "Kohtalot",
    metrics: "Mittarit",
    interplay: "Ristivaikutukset",
    noMetrics: "Tällä kululla ei ole mittariarviota: ratkaisuilla ei ole vielä vaikutusarvioita vipupisteiden mittareihin.",
    needsCourse: "Avautuu, kun lukittu ratkaisujoukko on kuviteltu.",
    courseStatus: {
      beforeLock: "Aikajana, kohtalot, mittarit ja vertailu avautuvat, kun ratkaisut on lukittu ja fasilitaattori on kuvitellut niille tulevaisuuden.",
      waiting: "Ratkaisut on lukittu. Aikajana, kohtalot, mittarit ja vertailu avautuvat, kun fasilitaattori on kuvitellut niille tulevaisuuden skenaarioissa.",
      running: "Tulevaisuutta kuvitellaan… Näkymät avautuvat, kun kuvittelu valmistuu.",
      failed: "Tulevaisuuden kuvittelu epäonnistui. Fasilitaattori voi käynnistää sen uudelleen.",
    },
  },
  panels: {
    stepCount: "{{count}} askelta",
    highlights: "Mitä kulun varrella huomataan",
    actions: "Toimenpiteet vuosittain",
    actionsFor: "Toimenpiteet vuosittain · {{name}} ensin",
    noActions: "Kulussa ei ole aikataulutettuja askeleita.",
  },
  compare: {
    title: "Skenaariot rinnakkain",
    solution: "Ratkaisu",
    set: "Koko joukko",
    robustness: "Kestävyys",
    lines: "Aikajanat samalla vuosiakselilla",
    tooFew: "Vertailtavaa on, kun ainakin kaksi skenaariota on kuviteltu.",
  },
  actor: {
    label: "Toimija",
    all: "Kaikki",
    hint: "Valitse organisaatiosi: sen askeleet korostuvat aikajanalla. Valinta muistetaan tällä laitteella.",
    count: "{{name}}: {{count}} askelta tässä kulussa",
    none: "{{name}} ei toimi tässä kulussa.",
  },
  line: {
    scrollHint: "Selaa sivusuunnassa →",
    step: "{{from}}–{{to}} · {{solution}}: {{step}}",
    stepActor: "Toimija: {{actor}}",
    stepPrecondition: "Edellytys: {{text}}",
    close: "Sulje",
  },
  effect: {
    title: "Vaikuttavuus: kuinka paljon ratkaisut ratkaisevat ongelman",
    intro: "Arvio tästä kulusta. Palvelin laskee, mihin kartan juurisyihin kukin ratkaisu yltää, ja laskee liian korkean arvion alemmas.",
    verdict: { marginal: "Ei juuri liikuta ongelmaa", eases: "Lievittää ongelmaa", fixes: "Korjaa ongelman", dissolves: "Poistaa ongelman lähtökohdan" },
    short: { marginal: "Ei juuri liikuta", eases: "Lievittää", fixes: "Korjaa", dissolves: "Poistaa lähtökohdan" },
    legend: {
      marginal: "ratkaisu yltää vain vähään tai ei mihinkään juurisyistä, tai se jää tässä kulussa liian vähäiseksi",
      eases: "ongelma pienenee tai lievenee, mutta suuri osa juurisyistä jää",
      fixes: "pääasialliset juurisyyt hoidetaan ja ongelma on pitkälti poissa, vaikka ympäröivä järjestelmä on ennallaan",
      dissolves: "paradigman muutos: juurisyyt poistuvat, ja ongelman lähtökohta on poissa",
    },
    set: "Koko ratkaisujoukko",
    perSolution: "Ratkaisut yksitellen",
    reached: "Yltää juurisyihin: {{names}}",
    reachedNone: "Ei yllä mihinkään kartan mitatuista juurisyistä.",
    coverage: "{{reached}} / {{total}} juurisyystä",
    remaining: "Juurisyyt, joihin mikään toteutuva ratkaisu ei yllä: {{names}}",
    premiseGone: "Miksi ongelman lähtökohta poistuu: {{text}}",
    lowered: "Tekoäly arvioi: {{from}}. Kartan perusteella enintään: {{to}} ({{reason}}).",
    loweredReason: {
      reaches_none: "ratkaisu ei yllä yhteenkään juurisyyhyn",
      reaches_under_half: "se yltää alle puoleen juurisyistä",
      reaches_under_most: "se yltää alle neljään viidesosaan juurisyistä",
      premise_not_argued: "lähtökohdan poistumista ei perusteltu",
      no_root_causes: "kartalla ei ole mitattuja juurisyitä, joihin sitä voisi verrata",
    },
    unjudged: "Tekoäly ei arvioinut tätä ratkaisua.",
    newIssues: "Uudet ongelmat, joita toteutus voisi synnyttää",
    newIssuesHint: "Päätelmiä, ei havaintoja: ne perustuvat ratkaisujen omiin vaikutuksiin, eikä niille ole lähdettä.",
    followsFrom: "Seuraa ratkaisuista: {{names}}",
    grounded: {
      adverse_move: "Perustuu ratkaisun haitalliseen vaikutukseen mittarissa",
      world_shift: "Perustuu kehitykseen, jota ratkaisu liikuttaa",
      reasoned: "Pelkkä päättely",
    },
    failed: "Vaikuttavuusarviota ei saatu: {{message}}",
    missing: "Vaikuttavuusarviota ei ole vielä tehty tälle kululle.",
    wall: "Vaikuttavuus: {{verdict}}",
  },
};

export const futureOutcomeEn = {
  scenario: {
    label: "Scenario",
    sources: { expert: "Expert scenarios", workshop: "The workshop's scenarios", own: "Own scenarios" },
    placeholder: "Placeholder: the experts' scenarios will replace these texts.",
    stale: "The scenario has changed since this course: imagine it again.",
    read: "Read the scenario",
    close: "Close",
    level: "Optimism level {{level}}",
    judged: "The solutions are judged realistically in this world: neither leniently nor harshly.",
  },
  reading: {
    title: "What the scenario does to the solutions' threats",
    pressure: { stronger: "strengthens", as_is: "leaves as is", weaker: "weakens", removed: "removes" },
    timing: { earlier: "earlier", same: "", later: "later" },
    kind: { trigger: "caused the fate", setAside: "threat set aside" },
    behind: "In the scenario: {{text}}",
    none: "The scenario does not change the threats behind this course's fates.",
    differs: "What differs between the scenarios",
    differsIntro: "The threats and relations the scenarios bear on differently, with the passage each judgement rests on. All the scenarios were read at once, side by side.",
    noDiffer: "The scenarios do not differ on the locked solutions' threats.",
    notRead: "The scenarios have not been read yet.",
    failed: "Reading the scenarios failed: {{message}}",
  },
  impact: {
    title: "The scenario and what it does",
    show: "Show the scenario's text",
    hide: "Hide the text",
  },
  worldAdmin: {
    title: "Scenarios",
    source: "Source: {{source}}, {{count}} scenarios. The source can be changed under Sisältö (Forecast scenarios).",
    none: "The chosen source has {{count}} scenarios; at least {{min}} are needed. Change the source or add scenarios under Sisältö.",
    simulate: "Imagine every scenario",
    simulating: "Imagining…",
    rerun: "Imagine again",
    analyse: "Assess effectiveness again",
    analysing: "Assessing…",
    readingStatus: { running: "being read", done: "read", failed: "reading failed" },
    status: { running: "being imagined", done: "done", failed: "failed" },
  },
  stageBar: {
    label: "Stages",
    interplay: "Interplay",
    voting: "Vote",
    locked: "Lock",
    simulated: "Future testing",
  },
  howWeGotHere: "How we got here: the interplay",
  lockedStrip: {
    label: "Locked",
    override: "The choice differs from the vote",
    stale: "changed since the lock",
  },
  views: {
    label: "View",
    timeline: "Timeline",
    compare: "Comparison",
    fates: "Fates",
    metrics: "Metrics",
    interplay: "Interplay",
    noMetrics: "This course has no metric outlook: the solutions have no estimates for the leverage points' metrics yet.",
    needsCourse: "Opens once the locked set of solutions has been imagined.",
    courseStatus: {
      beforeLock: "The timeline, fates, metrics and comparison views open once the solutions are locked and the facilitator has imagined their future.",
      waiting: "The solutions are locked. The timeline, fates, metrics and comparison views open once the facilitator has imagined their future in the scenarios.",
      running: "The future is being imagined… The views open when it is ready.",
      failed: "Imagining the future failed. The facilitator can start it again.",
    },
  },
  panels: {
    stepCount: "{{count}} steps",
    highlights: "What people would notice along the way",
    actions: "Actions by year",
    actionsFor: "Actions by year · {{name}} first",
    noActions: "The course has no scheduled steps.",
  },
  compare: {
    title: "The scenarios side by side",
    solution: "Solution",
    set: "The whole set",
    robustness: "Robustness",
    lines: "The timelines on one year axis",
    tooFew: "There is something to compare once at least two scenarios have been imagined.",
  },
  actor: {
    label: "Actor",
    all: "Everyone",
    hint: "Pick your organisation: its steps stand out on the timeline. The choice is remembered on this device.",
    count: "{{name}}: {{count}} steps in this course",
    none: "{{name}} does not act in this course.",
  },
  line: {
    scrollHint: "Swipe sideways →",
    step: "{{from}}–{{to}} · {{solution}}: {{step}}",
    stepActor: "Actor: {{actor}}",
    stepPrecondition: "Precondition: {{text}}",
    close: "Close",
  },
  effect: {
    title: "Effectiveness: how far the solutions deal with the issue",
    intro: "An assessment of this course. The server works out which root causes of the map each solution reaches, and lowers a verdict that goes further than that.",
    verdict: { marginal: "Barely moves the issue", eases: "Eases the issue", fixes: "Fixes the issue", dissolves: "Dissolves the issue's premise" },
    short: { marginal: "Barely moves it", eases: "Eases", fixes: "Fixes", dissolves: "Dissolves it" },
    legend: {
      marginal: "the solution reaches few or none of the root causes, or does too little in this course",
      eases: "the issue becomes smaller or milder, but much of the root causes stay",
      fixes: "the main root causes are dealt with and the problem is largely gone, though the system around it is as before",
      dissolves: "a paradigm shift: the root causes are removed and the issue's premise is gone",
    },
    set: "The whole set of solutions",
    perSolution: "Each solution",
    reached: "Reaches root causes: {{names}}",
    reachedNone: "Reaches none of the root causes the map measures.",
    coverage: "{{reached}} of {{total}} root causes",
    remaining: "Root causes no solution carried out reaches: {{names}}",
    premiseGone: "Why the issue's premise is gone: {{text}}",
    lowered: "The AI judged: {{from}}. From the map, at most: {{to}} ({{reason}}).",
    loweredReason: {
      reaches_none: "the solution reaches no root cause",
      reaches_under_half: "it reaches under half of the root causes",
      reaches_under_most: "it reaches under four fifths of the root causes",
      premise_not_argued: "it did not say why the premise is gone",
      no_root_causes: "the map has no measured root causes to compare with",
    },
    unjudged: "The AI did not assess this solution.",
    newIssues: "New issues carrying them out could create",
    newIssuesHint: "Reasoning, not findings: they rest on the solutions' own effects and have no source.",
    followsFrom: "Follows from: {{names}}",
    grounded: {
      adverse_move: "Rests on an adverse move of the solution on a metric",
      world_shift: "Rests on a development the solution moves",
      reasoned: "Reasoning only",
    },
    failed: "The effectiveness assessment failed: {{message}}",
    missing: "The effectiveness of this course has not been assessed yet.",
    wall: "Effectiveness: {{verdict}}",
  },
};

export const futureOutcomeSv = {
  scenario: {
    label: "Scenario",
    sources: { expert: "Expertscenarier", workshop: "Workshopens scenarier", own: "Egna scenarier" },
    placeholder: "Platshållare: experternas scenarier ersätter dessa texter.",
    stale: "Scenariot har ändrats sedan detta förlopp: föreställ det igen.",
    read: "Läs scenariot",
    close: "Stäng",
    level: "Optimismnivå {{level}}",
    judged: "Lösningarna bedöms realistiskt i den här världen: varken milt eller strängt.",
  },
  reading: {
    title: "Vad scenariot gör med lösningarnas hot",
    pressure: { stronger: "förstärker", as_is: "lämnar oförändrat", weaker: "försvagar", removed: "tar bort" },
    timing: { earlier: "tidigare", same: "", later: "senare" },
    kind: { trigger: "orsakade utfallet", setAside: "hot som åsidosattes" },
    behind: "I scenariot: {{text}}",
    none: "Scenariot ändrar inte hoten bakom detta förlopps utfall.",
    differs: "Vad skiljer scenarierna åt",
    differsIntro: "Hoten och relationerna som scenarierna påverkar olika, med det ställe varje bedömning vilar på. Alla scenarier lästes på en gång, sida vid sida.",
    noDiffer: "Scenarierna skiljer sig inte i fråga om de låsta lösningarnas hot.",
    notRead: "Scenarierna har inte lästs än.",
    failed: "Läsningen av scenarierna misslyckades: {{message}}",
  },
  impact: {
    title: "Scenariot och vad det gör",
    show: "Visa scenariots text",
    hide: "Dölj texten",
  },
  worldAdmin: {
    title: "Scenarier",
    source: "Källa: {{source}}, {{count}} scenarier. Källan kan bytas under Sisältö (Prognosens scenarier).",
    none: "Den valda källan har {{count}} scenarier; minst {{min}} behövs. Byt källa eller lägg till scenarier under Sisältö.",
    simulate: "Föreställ alla scenarier",
    simulating: "Föreställer…",
    rerun: "Föreställ igen",
    analyse: "Bedöm effekten igen",
    analysing: "Bedömer…",
    readingStatus: { running: "läses", done: "läst", failed: "läsningen misslyckades" },
    status: { running: "föreställs", done: "klart", failed: "misslyckades" },
  },
  stageBar: {
    label: "Skeden",
    interplay: "Samspel",
    voting: "Omröstning",
    locked: "Låsning",
    simulated: "Framtidstestning",
  },
  howWeGotHere: "Hur vi kom hit: samspelet",
  lockedStrip: {
    label: "Låst",
    override: "Valet avviker från omröstningen",
    stale: "ändrad efter låsningen",
  },
  views: {
    label: "Vy",
    timeline: "Tidslinje",
    compare: "Jämförelse",
    fates: "Öden",
    metrics: "Mätare",
    interplay: "Samspel",
    noMetrics: "Detta förlopp har ingen mätarbild: lösningarna har ännu inga bedömningar för hävstångspunkternas mätare.",
    needsCourse: "Öppnas när den låsta uppsättningen lösningar har föreställts.",
    courseStatus: {
      beforeLock: "Tidslinjen, öden, mätare och jämförelsen öppnas när lösningarna är låsta och facilitatorn har föreställt deras framtid.",
      waiting: "Lösningarna är låsta. Tidslinjen, öden, mätare och jämförelsen öppnas när facilitatorn har föreställt deras framtid i scenarierna.",
      running: "Framtiden föreställs… Vyerna öppnas när det är klart.",
      failed: "Det gick inte att föreställa framtiden. Facilitatorn kan starta det igen.",
    },
  },
  panels: {
    stepCount: "{{count}} steg",
    highlights: "Vad man skulle märka längs vägen",
    actions: "Åtgärder per år",
    actionsFor: "Åtgärder per år · {{name}} först",
    noActions: "Förloppet har inga schemalagda steg.",
  },
  compare: {
    title: "Scenarierna sida vid sida",
    solution: "Lösning",
    set: "Hela uppsättningen",
    robustness: "Robusthet",
    lines: "Tidslinjerna på samma årsaxel",
    tooFew: "Det finns något att jämföra när minst två scenarier har föreställts.",
  },
  actor: {
    label: "Aktör",
    all: "Alla",
    hint: "Välj din organisation: dess steg framhävs på tidslinjen. Valet sparas på den här enheten.",
    count: "{{name}}: {{count}} steg i det här förloppet",
    none: "{{name}} agerar inte i det här förloppet.",
  },
  line: {
    scrollHint: "Svep i sidled →",
    step: "{{from}}–{{to}} · {{solution}}: {{step}}",
    stepActor: "Aktör: {{actor}}",
    stepPrecondition: "Förutsättning: {{text}}",
    close: "Stäng",
  },
  effect: {
    title: "Effekt: hur långt lösningarna löser problemet",
    intro: "En bedömning av det här förloppet. Servern räknar ut vilka av kartans grundorsaker varje lösning når och sänker en bedömning som går längre än så.",
    verdict: { marginal: "Rör knappt problemet", eases: "Lindrar problemet", fixes: "Löser problemet", dissolves: "Upphäver problemets utgångspunkt" },
    short: { marginal: "Rör knappt", eases: "Lindrar", fixes: "Löser", dissolves: "Upphäver" },
    legend: {
      marginal: "lösningen når få eller inga av grundorsakerna, eller gör för lite i det här förloppet",
      eases: "problemet blir mindre eller mildare, men en stor del av grundorsakerna finns kvar",
      fixes: "de viktigaste grundorsakerna hanteras och problemet är i stort sett borta, även om systemet runt det är sig likt",
      dissolves: "ett paradigmskifte: grundorsakerna försvinner och problemets utgångspunkt är borta",
    },
    set: "Hela lösningsuppsättningen",
    perSolution: "Varje lösning",
    reached: "Når grundorsaker: {{names}}",
    reachedNone: "Når ingen av de grundorsaker kartan mäter.",
    coverage: "{{reached}} av {{total}} grundorsaker",
    remaining: "Grundorsaker som ingen genomförd lösning når: {{names}}",
    premiseGone: "Varför problemets utgångspunkt försvinner: {{text}}",
    lowered: "AI:n bedömde: {{from}}. Utifrån kartan högst: {{to}} ({{reason}}).",
    loweredReason: {
      reaches_none: "lösningen når ingen grundorsak",
      reaches_under_half: "den når under hälften av grundorsakerna",
      reaches_under_most: "den når under fyra femtedelar av grundorsakerna",
      premise_not_argued: "den motiverade inte varför utgångspunkten försvinner",
      no_root_causes: "kartan har inga uppmätta grundorsaker att jämföra med",
    },
    unjudged: "AI:n bedömde inte den här lösningen.",
    newIssues: "Nya problem som genomförandet kunde ge upphov till",
    newIssuesHint: "Slutledningar, inte iakttagelser: de vilar på lösningarnas egna effekter och saknar källa.",
    followsFrom: "Följer av: {{names}}",
    grounded: {
      adverse_move: "Vilar på en lösnings ogynnsamma verkan på ett mått",
      world_shift: "Vilar på en utveckling som lösningen flyttar",
      reasoned: "Enbart resonemang",
    },
    failed: "Effektbedömningen misslyckades: {{message}}",
    missing: "Effekten av det här förloppet har inte bedömts än.",
    wall: "Effekt: {{verdict}}",
  },
};
